import useFeature from '@/contexts/FeatureFlags/useFeature';

/**
 * The key that governs the "עדכונים" bell in the header. Must match FeatureFlagKeys.Updates on the
 * server and the row seeded by SeedFeatureFlag_Updates.sql.
 */
export const UPDATES_FEATURE_KEY = 'updates';

/**
 * Whether the updates bell is on for the current user.
 *
 * ⚠️ Read through GlobalFeatureFlagsProvider, which is mounted above the router - the header is
 * outside FundProvider, so the fund-scoped provider is not in scope here. Fund targeting therefore
 * does not apply to this flag; email and role targeting do, which is the right shape for a control
 * that belongs to no fund.
 *
 * Off is the answer whenever anything is missing - the flag row, the provider, the ruleset - which
 * is what keeps the bell from appearing on a deploy that nobody meant to release it in.
 */
export default function useUpdatesFeature(): boolean {
  return useFeature(UPDATES_FEATURE_KEY);
}
